import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { CurrencyPipe } from '@frontend/sports/common/core/feature/money';
import { TimerProgressBarComponent } from '@frontend/sports/common/ui/progress-bar';
import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { SportsThemedSwitch } from '@frontend/sports/common/ui/sports-themed-switch';
import { ModalDialogService } from '@frontend/sports/modal/feature';
import { OddsFormatterPipe } from '@frontend/sports/odds/feature';
import { DsButton } from '@frontend/ui/button';
import { DsSwitch } from '@frontend/ui/switch';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { EffectsModule } from '@ngrx/effects';
import { ShowInEpcotDirective } from 'packages/sports/web/app/src/common/epcot-config.directive';
import { EpcotNotificationComponent } from 'packages/sports/web/app/src/common/epcotNotifications/notification.component';
import { TimerModule } from 'packages/sports/web/app/src/timers/timer.module';

import BetslipBaseModule from '../../base/betslip-base.module';
import { BetslipDigitalIntegrationModule } from '../../integration/betslip-digital-integration.module';
import BetslipDigitalBetPlacementModule from '../betplacement/betslip-digital-betplacement.module';
import PickOddsModule from '../picks/pick-odds.module';
import BetslipDigitalTaxationModule from '../taxation/betslip-digital-taxation.module';
import { MESSAGE_FORMATTER_INJECTION_TOKEN } from '../validation/services/formatting/message-formatters/message-formatter';
import { BetslipOverAskContentComponent } from './components/digital/betslip-over-ask-content/betslip-over-ask-content.component';
import { BetslipOverAskGroupPickComponent } from './components/digital/betslip-over-ask-group-pick/betslip-over-ask-group-pick.component';
import { BetslipOverAskHeaderComponent } from './components/digital/betslip-over-ask-header/betslip-over-ask-header.component';
import { BetSlipOverAskMaxStakeSettingsComponent } from './components/digital/betslip-over-ask-maxstake/betslip-over-ask-maxstake-settings.component';
import { BetslipOverAskPendingComponent } from './components/digital/betslip-over-ask-pending/betslip-over-ask-pending.component';
import { BetslipOverAskPickListComponent } from './components/digital/betslip-over-ask-pick-list/betslip-over-ask-pick-list.component';
import { BetslipOveraskPlaceBetButtonComponent } from './components/digital/betslip-over-ask-place-bet-button/betslip-over-ask-place-bet-button.component';
import { BetslipOverAskReviewComponent } from './components/digital/betslip-over-ask-review/betslip-over-ask-review.component';
import { BetSlipOverAskStakeChangeConfirmationComponent } from './components/digital/betslip-over-ask-stakechange/betslip-over-ask-stakechange-confirmation.component';
import { BetslipOverAskSummaryErrorsComponent } from './components/digital/betslip-over-ask-summary/betslip-over-ask-summary-errors.component';
import { BetslipOveraskSummaryComponent } from './components/digital/betslip-over-ask-summary/betslip-over-ask-summary.component';
import { BetslipOverAskComponent } from './components/digital/betslip-over-ask.component';
import { BetslipOverAskBetRemoveComponent } from './components/digital/picks/betslip-over-ask-bet-remove.component';
import { BetslipOverAskPickBetBuilderComponent } from './components/digital/picks/betslip-over-ask-pick-bet-builder.component';
import { BetslipOverAskPickChangesComponent } from './components/digital/picks/betslip-over-ask-pick-changes.component';
import { BetslipOverAskPickOptionMarketComponent } from './components/digital/picks/betslip-over-ask-pick-option-market.component';
import { BetslipOverAskPickParticipantComponent } from './components/digital/picks/betslip-over-ask-pick-participant.component';
import { BetslipOverAskPickPossibleWinningsComponent } from './components/digital/picks/betslip-over-ask-pick-possible-winnings.component';
import { BetslipOverAskPickRemovedOverlayComponent } from './components/digital/picks/betslip-over-ask-pick-removed-overlay.component';
import { BetslipOverAskPickSelectorComponent } from './components/digital/picks/betslip-over-ask-pick-selector.component';
import { DigitalOverAskEffects } from './effects/digital-over-ask.effects';
import { OverAskPlaceEffects } from './effects/over-ask-place.effects';
import { OverAskTrackingEffects } from './effects/over-ask-tracking.effects';
import { OverAskEffects } from './effects/over-ask.effects';
import { BetslipOverAskSharedModule } from './over-ask-shared.module';
import { OverAskModule } from './over-ask.module';
import { BetslipOverAskStateStorageService } from './services/betslip-over-ask-state-storage';
import { OverAskDigitalMessagesProvider } from './services/digital/over-ask-digital-messages.provider';
import { OverAskMessageFormatter } from './services/over-ask-message-formatter.service';
import { OverAskMessagesProvider } from './services/over-ask-messages.provider';
import { OverAskRejectOfferModalDialogService } from './services/over-ask-reject-offer-modal-dialog.service';

@NgModule({
    declarations: [
        BetslipOverAskComponent,
        BetslipOverAskContentComponent,
        BetslipOverAskHeaderComponent,
        BetslipOverAskPendingComponent,
        BetslipOverAskReviewComponent,
        BetslipOverAskPickListComponent,
        BetslipOverAskSummaryErrorsComponent,
        BetslipOveraskSummaryComponent,
        BetslipOveraskPlaceBetButtonComponent,
        BetslipOverAskPickSelectorComponent,
        BetslipOverAskPickBetBuilderComponent,
        BetslipOverAskPickOptionMarketComponent,
        BetslipOverAskPickParticipantComponent,
        BetslipOverAskPickRemovedOverlayComponent,
        BetslipOverAskPickChangesComponent,
        BetslipOverAskPickPossibleWinningsComponent,
        BetslipOverAskBetRemoveComponent,
        BetSlipOverAskStakeChangeConfirmationComponent,
        BetSlipOverAskMaxStakeSettingsComponent,
        BetslipOverAskGroupPickComponent,
    ],
    imports: [
        CommonModule,
        BetslipBaseModule,
        BetslipDigitalIntegrationModule,
        AutomationModule,
        TimerProgressBarComponent,
        TimerModule,
        OverAskModule,
        BetslipOverAskSharedModule,
        BetslipDigitalTaxationModule,
        BetslipDigitalBetPlacementModule,
        FormsModule,
        EffectsModule.forFeature([OverAskEffects, DigitalOverAskEffects, OverAskPlaceEffects, OverAskTrackingEffects]),
        ShowInEpcotDirective,
        EpcotNotificationComponent,
        DsButton,
        SportsThemedButtonDirective,
        PickOddsModule,
        OddsFormatterPipe,
        CurrencyPipe,
        DsSwitch,
        IconCustomComponent,
        SportsThemedSwitch,
    ],
    exports: [BetslipOverAskComponent, BetSlipOverAskStakeChangeConfirmationComponent, BetSlipOverAskMaxStakeSettingsComponent],
    providers: [
        OverAskRejectOfferModalDialogService,
        OverAskDigitalMessagesProvider,
        BetslipOverAskStateStorageService,
        ModalDialogService,
        { provide: OverAskMessagesProvider, useExisting: OverAskDigitalMessagesProvider },
        { provide: MESSAGE_FORMATTER_INJECTION_TOKEN, useClass: OverAskMessageFormatter, multi: true },
    ],
})
export class BetslipOverAskDigitalModule {}
